import { render, staticRenderFns } from "./mobile_trading_register.vue?vue&type=template&id=6953d150&scoped=true&"
import script from "./mobile_trading_register.vue?vue&type=script&lang=js&"
export * from "./mobile_trading_register.vue?vue&type=script&lang=js&"
import style0 from "./mobile_trading_register.vue?vue&type=style&index=0&id=6953d150&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6953d150",
  null
  
)

export default component.exports